var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkChartStyleHeikinAshi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14272 2.57143V9.42857H2.85701V2.57143H1.14272ZM0.571291 2.28457C0.571291 2.12743 0.694149 2 0.855863 2H3.14386C3.30101 2 3.42843 2.12571 3.42843 2.28457V9.71543C3.42882 9.75291 3.42172 9.79008 3.40755 9.82478C3.39338 9.85948 3.37244 9.891 3.34594 9.9175C3.31943 9.944 3.28791 9.96495 3.25321 9.97912C3.21852 9.99328 3.18134 10.0004 3.14386 10H0.855863C0.81845 10.0002 0.781377 9.99289 0.746783 9.97865C0.712189 9.9644 0.680759 9.94344 0.654304 9.91699C0.627848 9.89053 0.606892 9.8591 0.592645 9.82451C0.578397 9.78991 0.57114 9.75284 0.571291 9.71543V2.28457Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71436 0.285721H2.28578V2.28572H1.71436V0.285721ZM5.71436 1.42858V4.85715H7.42864V1.42858H5.71436ZM5.14293 1.14286C5.14293 0.985149 5.26578 0.857149 5.4275 0.857149H7.7155C7.87264 0.857149 8.00007 0.988578 8.00007 1.14286V5.14286C8.00007 5.30058 7.87721 5.42858 7.7155 5.42858H5.4275C5.35206 5.42783 5.27994 5.39745 5.2267 5.344C5.17346 5.29055 5.14337 5.2183 5.14293 5.14286V1.14286Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkChartStyleHeikinAshi);
export default __webpack_public_path__ + "static/media/dark-chart-style-heikin-ashi.4b5707df39d0ec34cebf46732d375950.svg";
export { ForwardRef as ReactComponent };